import React, { useState } from "react";
import { BiHide, BiShowAlt } from "react-icons/bi";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { successNotify } from "../../Services/Notification";
import { Helmet } from "react-helmet";
import MirageLoader from "../../components/ui/pageLoader/MirageLoader";

const ForgetPasswordNewPassword = () => {
  const currentUrl = window.location.href;

  const orgSchemeData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "I4invest",
    url: "https://i4invest.in/",
    logo: "https://i4invest.in/images/logo.png",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+91-9769699957",
      contactType: "customer service",
      contactOption: "TollFree",
      areaServed: "IN",
      availableLanguage: "en",
    },
  };

  const navigate = useNavigate();

  const { token } = useSelector((state) => state.customReducer);

  // create password
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [errorsData, setErrorsData] = useState({
    newPassword: [],
    confirmPassword: [],
  });
  const [isButtonClicked, setIsButtonClicked] = useState();

  // create password
  const validateForm = () => {
    let formErrors = {
      newPassword: [],
      confirmPassword: [],
    };
    let isValid = true;

    // Password validation
    let passwordErrors = [];
    if (!newPassword) {
      passwordErrors.push("Please Enter a password");
      formErrors.newPassword = passwordErrors;
      isValid = false;
      setIsButtonClicked(false);
    }
    if (newPassword && newPassword.length < 8) {
      // formErrors.password.push('Password should be at least 8 characters long');
      passwordErrors.push("Must be atleast 8 characters long");
      formErrors.newPassword = passwordErrors;
      isValid = false;
      setIsButtonClicked(false);
    }
    if (newPassword && !validatePassword(newPassword)) {
      // formErrors.password.push('Password should be at least 8 characters long');
      passwordErrors.push("Atleast one digit (0-9) & special character (#&@%)");
      formErrors.newPassword = passwordErrors;
      isValid = false;
      setIsButtonClicked(false);
    }
    if (newPassword && !isValidPassword(newPassword)) {
      passwordErrors.push("Use atleast one Upper Case letter");
      formErrors.newPassword = passwordErrors;
      isValid = false;
      setIsButtonClicked(false);
    }

    // Confirm password validation
    if (!confirmPassword) {
      formErrors.confirmPassword = "";
      isValid = false;
      setIsButtonClicked(false);
    } else if (confirmPassword !== newPassword) {
      formErrors.confirmPassword = "Passwords do not match";
      isValid = false;
      setIsButtonClicked(false);
    }

    setErrorsData(formErrors);
    return isValid;
  };

  const isValidPassword = (password) => {
    // Custom password validation function
    return /^(?=.*[A-Za-z])(?=.*\d)/.test(password);
  };

  const validatePassword = (password) => {
    const specialChars = /[@#$%]/;
    return specialChars.test(password);
  };

  const passwordHandleSubmit = (e) => {
    setIsButtonClicked(true);
    e.preventDefault();
    if (validateForm()) {
      forgetPassword("api/user/changepassword");
    }
  };

  const forgetPassword = async (url) => {
    await axios({
      method: "post",
      headers: {
        Authorization: "Bearer " + token,
      },
      url: process.env.REACT_APP_API_URL + url,
      data: {
        password: newPassword,
        password2: confirmPassword,
      },
    })
      .then(async (response) => {
        if (response.data.status_code == 200) {
          successNotify(response?.data?.message);
          setIsButtonClicked(false);
          navigate("/login");
          sessionStorage.clear();
        }
        
      })
      .catch((error) => {
        console.log(error);
        setIsButtonClicked(false);
      });
  };
  return (
    <div className="p-8 md:flex">
      <Helmet>
        <link rel="canonical" href={currentUrl} />
        <title>New Password - I4Invest</title>
        <meta
          name="description"
          content="I4Invest offers top portfolio management software for advisors and investors. Track and manage investments with India’s best mutual fund portfolio tracker app. Call us!"
        />
        <meta
          property="og:image"
          content="https://i4invest.in/logo_i4invest-01.png"
        />
        <meta name="robots" content="index, follow" />
        <script type="application/ld+json">
          {JSON.stringify(orgSchemeData)}
        </script>
      </Helmet>
      <div className="w-full bg-[#ffffff] pt-[130px] md:pb-[80px]">
        <div className="mx-auto max-w-[1400px] px-[16px] md:px-0">
          <div className="flex items-center justify-start gap-[25px] md:gap-[45px]">
            <img
              className="w-full max-w-[35px] max-md:hidden"
              src="images/Back-Arrow-btn.png"
              alt=""
              onClick={() => {
                navigate("/forget-password-otp");
              }}
            />
            <h2 className="font-open text-[20px] font-[700] leading-[30px] text-[#1E1E1E] md:text-[24px] md:leading-[36px]">
              Create A New Password
            </h2>
          </div>
        </div>

        <div className="mx-auto mt-4 max-w-[1235px] px-[16px] md:ml-[80px] md:px-0">
          <div className="flex flex-wrap items-start justify-between pt-[35px] md:flex-nowrap">
            <div className="w-full md:w-[322px]">
              <form onSubmit={passwordHandleSubmit} action="">
                <div className="password-hover">
                  <label
                    className="mb-[5px] font-open text-[16px] font-[600] leading-[24px] text-[#1E1E1E]"
                    htmlFor="password"
                  >
                    Enter New Password
                  </label>
                  <div className="password-aline">
                    <div className="hover-imgs">
                      <img src="images/info-img.png" alt="" />
                    </div>
                    <div className="password-hover-show">
                      <img src="images/hovers-img.png" alt="" />
                    </div>
                  </div>
                </div>
                <div class="password-visible-icons">
                  <input
                    className="mb-2 mt-[12px] w-full rounded-[8px] border border-[#B6B6B6] bg-[#F7F7F7] px-[16px] py-[12px] font-open text-[16px] font-[400] leading-[24px] text-[#999696] outline-0"
                    type={passwordVisible ? "text" : "password"}
                    name="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Enter Here"
                  />
                  <button
                    class="password-visib-icns"
                    type="button"
                    onClick={() => setPasswordVisible(!passwordVisible)}
                  >
                    {passwordVisible ? <BiShowAlt /> : <BiHide />}
                  </button>
                  <div className="error-btn">
                    {errorsData.newPassword.length === 1 ? (
                      <span className="error">{errorsData.newPassword}</span>
                    ) : (
                      <ul>
                        {errorsData.newPassword.map((error, index) => {
                          return (
                            <li key={index}>
                              <span className="error">{error}</span>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </div>
                </div>

                <p className="pt-[30px] font-open text-[16px] font-[600] leading-[24px] text-[#1E1E1E]">
                  Confirm Password*
                </p>
                <div class="password-visible-icons">
                  <input
                    className="mb-2 mt-[12px] w-full rounded-[8px] border border-[#B6B6B6] bg-[#F7F7F7] px-[16px] py-[12px] font-open text-[16px] font-[400] leading-[24px] text-[#999696] outline-0"
                    type={confirmPasswordVisible ? "text" : "password"}
                    name="password2"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Enter Here"
                  />
                  <button
                    class="password-visib-icns"
                    type="button"
                    onClick={() =>
                      setConfirmPasswordVisible(!confirmPasswordVisible)
                    }
                  >
                    {confirmPasswordVisible ? <BiShowAlt /> : <BiHide />}
                  </button>
                  {errorsData.confirmPassword && (
                    <span className="error">{errorsData.confirmPassword}</span>
                  )}
                </div>
                <button
                  className={` ${isButtonClicked ? "opacity-[70%]" : ""}  mt-[50px] w-full rounded-[6px] bg-[#F2673A] px-[24px] py-[10px] font-open text-[16px] font-[600] tracking-[0.003px] text-[#ffffff] hover:bg-[#A94829] md:px-[32px] md:py-[13px]`}
                  type="submit"
                  disabled={isButtonClicked}
                >
                  {isButtonClicked ? <MirageLoader /> : "CREATE"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className=" h-fit max-md:mt-[40px] md:my-auto md:mr-[10%] md:mt-[100px]">
        <h2 className="text-center font-open text-[30px] font-[700] uppercase leading-[40px] text-[#231C42] md:text-[40px] md:leading-[60px]">
          Invest{" "}
          <span className="inline-block whitespace-nowrap md:block">
            With Confidence
          </span>
        </h2>
        <p className="mx-auto w-full pt-[10px] text-center font-open text-[14px] font-[600] leading-[24px] text-[#B6B6B6] md:w-[347px]">
          Unlock Your Investment Potential with Precision Portfolio Management
        </p>
        <div>
          <img className="w-full" src="images/Financial-growth.png" alt="" />
        </div>
      </div>
    </div>
  );
};

export default ForgetPasswordNewPassword;
